module.exports = __webpack_public_path__ + "img/empty-page-img1.565dec36.svg";